import { Subject } from 'rxjs';

const subject = new Subject();

export default {
    getMessage: () => subject.asObservable(),
    sendMessage: (message) => subject.next(message),
}